"use client";

import { useEffect, useState } from "react";
import { languageSwitchHref } from "@/components/guide-public/guide-links";
import type { GuideLang } from "@/lib/virtualspace/guide/guide-public-shape";

/**
 * The language switch: on the server it points at the page's plain
 * other-language address; once mounted it keeps the visitor's place (the
 * region, filters and section they were looking at) by rewriting itself
 * from the live address.
 */
export function GuideLanguageLink({
  href,
  to,
  label,
  ariaLabel,
  style,
}: {
  href: string;
  to: GuideLang;
  label: string;
  ariaLabel: string;
  style?: React.CSSProperties;
}) {
  const [live, setLive] = useState(href);
  useEffect(() => {
    const sync = () => setLive(languageSwitchHref(`${window.location.pathname}${window.location.search}${window.location.hash}`, to));
    sync();
    window.addEventListener("popstate", sync);
    window.addEventListener("hashchange", sync);
    return () => {
      window.removeEventListener("popstate", sync);
      window.removeEventListener("hashchange", sync);
    };
  }, [to]);
  return (
    <a
      href={live}
      hrefLang={to}
      lang={to}
      aria-label={ariaLabel}
      onFocus={() => setLive(languageSwitchHref(`${window.location.pathname}${window.location.search}${window.location.hash}`, to))}
      style={style}
    >
      {label}
    </a>
  );
}
